import { jsx as _jsx } from "react/jsx-runtime";
import { DialogTitle } from "@headlessui/react";
export const ModalHeader = ({ children }) => {
    return (_jsx("div", { className: "flex h-10 max-h-16", children: _jsx("div", { className: "self-center", children: _jsx(DialogTitle, { as: "h3", className: "text-primaryText dark:text-dark-primaryText text-lg font-medium leading-6", children: children }) }) }));
};
export default ModalHeader;
